module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.disabled ? 'vux-checklist-disabled' : ''
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "weui-cells__title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._t("after-title"), _vm._v(" "), _vm._l((_vm.currentOptions), function(one, index) {
    return _c('grid', {
      key: one.id,
      attrs: {
        "cols": 1
      }
    }, [_c('grid-item', [_c('div', {
      staticClass: "weui-cells_checkbox"
    }, [_c('label', {
      staticClass: "weui-cell weui-check_label",
      class: {
        'vux-checklist-label-left': _vm.labelPosition === 'left'
      },
      attrs: {
        "for": ("checkbox_" + _vm.uuid + "_" + index)
      }
    }, [_c('div', {
      staticClass: "weui-cell__hd"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.currentValue),
        expression: "currentValue"
      }],
      staticClass: "weui-check",
      attrs: {
        "type": "checkbox",
        "name": ("vux-checkbox-" + _vm.uuid),
        "id": _vm.disabled ? '' : ("checkbox_" + _vm.uuid + "_" + index),
        "disabled": _vm.isDisabled(one.id)
      },
      domProps: {
        "value": one.id,
        "checked": Array.isArray(_vm.currentValue) ? _vm._i(_vm.currentValue, one.id) > -1 : (_vm.currentValue)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.currentValue,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = one.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.currentValue = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.currentValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.currentValue = $$c
          }
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "weui-icon-checked vux-checklist-icon-checked"
    })]), _vm._v(" "), _c('div', {
      staticClass: "weui-cell__bd"
    }, [(one.showOption != '2') ? _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.getValue(one.optionName + ' '))
      }
    }) : _vm._e(), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.getValue(one.optionContent))
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "weui-cell__hd"
    }, [(one.img) ? _c('img', {
      staticStyle: {
        "width": "80px",
        "border-radius": "10px"
      },
      attrs: {
        "src": one.img
      }
    }) : _vm._e()])])])]), _vm._v(" "), (one.supInput === '1' && one.inputType === '1' && one.showOk) ? _c('grid-item', {
      ref: one.id,
      refInFor: true
    }, [_c('datetime', {
      attrs: {
        "placeholder": one.supTitle === '' ? '请选择' : one.supTitle
      },
      on: {
        "on-change": function($event) {
          _vm.setInput(one)
        }
      },
      model: {
        value: (one.inputVal),
        callback: function($$v) {
          _vm.$set(one, "inputVal", $$v)
        },
        expression: "one.inputVal"
      }
    })], 1) : _vm._e(), _vm._v(" "), (one.supInput === '1' && one.inputType === '2' && one.showOk) ? _c('grid-item', [_c('x-input', {
      ref: one.id,
      refInFor: true,
      staticClass: "x-input-color",
      attrs: {
        "text-align": "right",
        "placeholder": one.supTitle === '' ? '请填写' : one.supTitle
      },
      on: {
        "on-change": function($event) {
          _vm.setInput(one)
        }
      },
      model: {
        value: (one.inputVal),
        callback: function($$v) {
          _vm.$set(one, "inputVal", $$v)
        },
        expression: "one.inputVal"
      }
    })], 1) : _vm._e(), _vm._v(" "), (one.supInput === '1' && (one.inputType === '3' || one.inputType === '4') && one.showOk) ? _c('grid-item', {
      ref: one.id,
      refInFor: true
    }, [_c('cell', {
      ref: one.id,
      refInFor: true,
      attrs: {
        "text-align": "right",
        "is-link": "",
        "required": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.setCheck(one.inputVal, index)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "color": "red"
      },
      domProps: {
        "innerHTML": _vm._s((!one.inputVal || one.inputVal === '') ? one.supTitle === '' ? '请选择' : one.supTitle : one.inputVal)
      }
    })]), _vm._v(" "), _c('div', {
      directives: [{
        name: "transfer-dom",
        rawName: "v-transfer-dom"
      }]
    }, [_c('popup', {
      staticClass: "checker-popup",
      model: {
        value: (_vm.showPopup),
        callback: function($$v) {
          _vm.showPopup = $$v
        },
        expression: "showPopup"
      }
    }, [_c('div', {
      staticStyle: {
        "padding": "10px 10px 40px 10px"
      }
    }, [_c('rater', {
      staticStyle: {
        "padding": "10px 15px"
      },
      attrs: {
        "margin": 4,
        "active-color": "#1957e8"
      },
      nativeOn: {
        "click": function($event) {
          _vm.getGrape()
        }
      },
      model: {
        value: (_vm.choiceValue),
        callback: function($$v) {
          _vm.choiceValue = $$v
        },
        expression: "choiceValue"
      }
    })], 1)])], 1)], 1) : _vm._e(), _vm._v(" "), (one.supInput === '1' && one.inputType === '5' && one.showOk) ? _c('div', {
      ref: one.id,
      refInFor: true
    }, [_c('rater', {
      staticStyle: {
        "padding": "10px 15px"
      },
      attrs: {
        "margin": 4,
        "active-color": "#1957e8"
      },
      nativeOn: {
        "click": function($event) {
          _vm.getGrape2()
        }
      },
      model: {
        value: (one.inputVal),
        callback: function($$v) {
          _vm.$set(one, "inputVal", $$v)
        },
        expression: "one.inputVal"
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (one.inputIndex == 1),
        expression: "one.inputIndex == 1"
      }],
      staticClass: "warnIcon",
      attrs: {
        "type": "warn"
      }
    })], 1)
  }), _vm._v(" "), _vm._t("footer")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-146e871e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subjects/Checklistspec/index.vue
// module id = BNlj
// module chunks = 6